function unFocusLastField({ state }) {
  let lastFocus = state.get('client.registrating.hasFocus')
  if (lastFocus) {
    state.merge(lastFocus, { hasFocus: false })
    state.set('client.registrating.hasFocus', null)
  }
}

export default unFocusLastField



// WEBPACK FOOTER //
// ./src/modules/client/actions/unFocusLastField.js